module.exports = __webpack_public_path__ + "img/dt-logo-wht-no-subs.aac133fe.png";